import { ComponentsSupportingDefaultProps } from '../types/HoneycombComponents';
import { filterProps } from '../utils';
import { useHoneycombTheme } from './useHoneycombTheme';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useComponentDefaultProps<T extends Record<string, any>, U extends Partial<T> = Partial<T>>(
    component: ComponentsSupportingDefaultProps,
    defaultProps: U,
    props: T
): T & {
    [Key in Extract<keyof T, keyof U>]-?: U[Key] | NonNullable<T[Key]>;
} {
    const { theme } = useHoneycombTheme();
    const themeDefaultProps = theme.components.defaultProps[component];
    const contextProps = typeof themeDefaultProps === 'function' ? themeDefaultProps(theme) : themeDefaultProps;

    const output = { ...defaultProps, ...contextProps, ...filterProps(props) };
    return output;
}
